import { labelList } from './text.js';
/**
 * The agency's profile digest in words (spec 3.17, Phase 5), PURE and shared, so the daily email (server lib/digest.ts)
 * and the dashboard (client components/profile/ProfileDigest.tsx) say it the same way. Labels, the agency's own client
 * names and counts only, never a value.
 */
/** A client's name as the digest shows it. */
export const digestName = (name) => name || 'A client';
/** What one client's talent did since the last digest, as sentence parts ("updated Height and Weight", "answered 2 requests"). */
export function digestClientParts(c) {
    return [
        c.updated.length ? `updated ${labelList(c.updated)}` : '',
        c.shared.length ? `shared ${labelList(c.shared)}` : '',
        c.stopped.length ? `stopped sharing ${labelList(c.stopped)}` : '',
        c.accepted.length ? `accepted your change to ${labelList(c.accepted)}` : '',
        c.kept.length ? `kept their ${labelList(c.kept)}` : '',
        c.answered ? `answered ${c.answered === 1 ? '1 request' : `${c.answered} requests`}` : '',
        c.declined.length ? `declined ${labelList(c.declined)}` : '',
    ].filter(Boolean);
}
/** After the name of a client whose talent left. */
export const DIGEST_LEFT_TEXT = 'left your agency';
/** After the count of shared details that may be out of date ("3 shared details may be out of date"). */
export const digestStaleText = (n) => `shared ${n === 1 ? 'detail' : 'details'} may be out of date`;
/**
 * News: a client's update or a talent who left. THE rule of the daily send (the server's digestEmpty), the email and the
 * dashboard's strip alike: a count of details that may be out of date is shown only beside news, never alone (most
 * values carried over from before one profile have no confirmation date yet, and the agency cannot act on them).
 */
export const digestHasNews = (d) => d.clients.length > 0 || d.left.length > 0;
//# sourceMappingURL=digest.js.map